module.exports = __webpack_public_path__ + "static/media/loader.4ffa712b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/requisitions/loader.svg
// module id = 184
// module chunks = 0